import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navbar from './components/navbar';
import Pagebanner from './components/pageBanner';
import { AboutIsc, PropertyExchange, Propertyavailableexchange, NoMatch, KnowMoreIsc} from './components/index';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';
import HomePage from './components/homePage';
import ProperyScreening from './components/PropertyScreening';
import PropertyList from './components/PropertyList';
import PropertyAdd from './components/PropertyAdd';
import PropertyListDetails from './components/propertyListingDetails';
import { PrivacyPolicy } from './components/PrivacyPolicy';
const routing=(
  <Router>
      <Route exact path={`${process.env.PUBLIC_URL}/`} component={HomePage}>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}/property-screening`} component={ProperyScreening}>
      </Route>
      <Route exact path={`${process.env.PUBLIC_URL}/property-list`} component={PropertyList}>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}/property-add`} component={PropertyAdd}>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}/property-list/:id`} component={PropertyListDetails}>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}/privacy-policy`} component={PrivacyPolicy}>
      </Route>
      
      
      
     

  </Router>
);
ReactDOM.render(
  routing,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
